import { Inject, Injectable, Injector } from '@angular/core';

import { Utilities_ReportService } from './Utilities.report.index';
import { ExcelOrderImport_ReportService } from './ExcelOrderImport.report.index';
import { TransloadOrders_ReportService } from './TransloadOrders.report.index';
import { PurchaseOrders_ReportService } from './PurchaseOrders.report.index';
import { FootprintApiManager_ReportService } from './FootprintApiManager.report.index';


@Injectable({ providedIn: 'root' })
export class app_ReportService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_ReportService);
    this.ExcelOrderImport = this.injector.get(ExcelOrderImport_ReportService);
    this.TransloadOrders = this.injector.get(TransloadOrders_ReportService);
    this.PurchaseOrders = this.injector.get(PurchaseOrders_ReportService);
    this.FootprintApiManager = this.injector.get(FootprintApiManager_ReportService);
  }
    public Utilities: Utilities_ReportService;
    public ExcelOrderImport: ExcelOrderImport_ReportService;
    public TransloadOrders: TransloadOrders_ReportService;
    public PurchaseOrders: PurchaseOrders_ReportService;
    public FootprintApiManager: FootprintApiManager_ReportService;

  public app: app_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

